/* Kiddocap — page produit premium (main-product-premium.liquid)
 *
 * 2026-09-08 : la logique JS de la section vit ici, en fichier asset (mis en
 * cache par le navigateur) au lieu d'un gros <script> inline. La section ne
 * garde que le « boot » : PATTERN_MAP + CONFIG (valeurs Liquid), qu'elle pousse
 * dans window.KDC_PP_BOOT. Ce fichier initialise chaque section poussée.
 * Aucune logique n'a changé au déplacement, sauf les deux réglages ajoutés le
 * même jour (enablePatternPreview, enableUpsellPopup, voir CONFIG dans la section).
 */
(function () {
  function initSection(root, PATTERN_MAP, CONFIG) {
    var SID = CONFIG.sectionId;

    const mediaItems = Array.from(root.querySelectorAll('.kdc-media-item'));
    const slidesEl = root.querySelector('#KDC-Slides-' + SID + '');
    const mediaStage = root.querySelector('#KDC-MediaStage-' + SID + '');
    const mediaDots = root.querySelector('#KDC-MediaDots-' + SID + '');
    const mediaPrev = root.querySelector('#KDC-MediaPrev-' + SID + '');
    const mediaNext = root.querySelector('#KDC-MediaNext-' + SID + '');
    const swipeLayer = root.querySelector('#KDC-MediaSwipe-' + SID + '');

    const qtyInput = root.querySelector('#KDC-Qty-' + SID + '');
    const qtyMinus = root.querySelector('#KDC-QtyMinus-' + SID + '');
    const qtyPlus = root.querySelector('#KDC-QtyPlus-' + SID + '');
    const selectedLine = root.querySelector('#KDC-SelectedLine-' + SID + '');
    const swatchRow = root.querySelector('#KDC-SwatchRow-' + SID + '');
    const variantSummary = null;
    const priceCurrent = root.querySelector('#KDC-PriceCurrent-' + SID + '');
    const priceCompare = root.querySelector('#KDC-PriceCompare-' + SID + '');
    const priceBadges = root.querySelector('#KDC-PriceBadges-' + SID + '');
    const discountBadge = root.querySelector('#KDC-DiscountBadge-' + SID + '');
    const shippingLine = root.querySelector('#KDC-ShippingLine-' + SID + '');
    const feedbackEl = root.querySelector('#KDC-Feedback-' + SID + '');
    const deliveryInlineEl = root.querySelector('#KDC-DeliveryEstimateInline-' + SID + '');
    const addToCartBtn = root.querySelector('#KDC-AddToCart-' + SID + '');
    const buyNowBtn = root.querySelector('#KDC-BuyNow-' + SID + '');

    const toast = root.querySelector('#KDC-Toast-' + SID + '');
    const toastInner = root.querySelector('#KDC-ToastInner-' + SID + '');

    const upsell = root.querySelector('#KDC-Upsell-' + SID + '');
    const upsellSwatches = root.querySelector('#KDC-UpsellSwatches-' + SID + '');
    const upsellPrice = root.querySelector('#KDC-UpsellPrice-' + SID + '');
    const upsellPrimary = root.querySelector('#KDC-UpsellPrimary-' + SID + '');
    const upsellSecondary = root.querySelector('#KDC-UpsellSecondary-' + SID + '');
    const upsellCloseEls = upsell ? upsell.querySelectorAll('[data-upsell-close]') : [];

    const state = {
      quantity: 1,
      protectionSelections: [CONFIG.defaultPatternKey],
      activeUnit: 0,
      upsellHatPatternKey: CONFIG.defaultPatternKey,
      pendingBuyNowItems: null,
      upsellMode: null,
      galleryPatternKey: null,
      gallerySlides: [],
      galleryItems: [],
      activeSlideIndex: 0,
      // Auto-cycle of the 4 patterns before the user picks one. OFF by default
      // since 2026-09-08 (Russel): the page starts on the default pattern and
      // stays there until the customer clicks another swatch.
      previewActive: !!CONFIG.enablePatternPreview,
      previewIndex: 0,
      autoplayTimer: null,
      touchStartX: 0,
      touchStartY: 0,
      touchStartTime: 0,
      touchDeltaX: 0,
      swipeAxis: null
    };

    // 2026-10-08 (Émile): Canadian dollars written clearly, FR "52,49 $ CA", EN "CA$52.49" (same as snippets/kdc-money.liquid).
    function money(cents) {
      var fr = CONFIG.isFrench;
      var n = new Intl.NumberFormat(fr ? 'fr-CA' : 'en-CA', { style: 'currency', currency: 'CAD' }).format((cents || 0) / 100);
      return fr ? n + ' CA' : 'CA' + n;
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 989px)').matches;
    }

    function getPatternByKey(key) {
      return PATTERN_MAP.find(function(item) { return item.key === key; }) || PATTERN_MAP[0];
    }

    function getPatternLabel(pattern) {
      return CONFIG.isFrench ? (pattern.labelFr || pattern.key) : (pattern.labelEn || pattern.key);
    }

    function getMediaForPattern(patternKey) {
      const items = mediaItems
        .filter(function(item) { return item.dataset.patternKey === patternKey; })
        .map(function(item) {
          return {
            role: item.dataset.mediaRole,
            mediaType: item.dataset.mediaType || 'image',
            src: item.dataset.src,
            sdSrc: item.dataset.srcSd || '',
            srcset: item.dataset.srcset,
            poster: item.dataset.poster,
            alt: item.dataset.alt
          };
        });

      return {
        swatch: items.find(function(item) { return item.role === 'swatch'; }) || null,
        // 2026-10-01 (Émile): optional short video that loops on the SELECTED swatch
        // (block "Pattern media", role "Swatch video"). The still image stays underneath.
        swatchVideo: items.find(function(item) { return item.role === 'swatch_video' && item.mediaType === 'video' && item.src; }) || null,
        gallery: items.filter(function(item) { return item.role === 'gallery'; })
      };
    }

    function clearAutoplay() {
      if (state.autoplayTimer) {
        window.clearTimeout(state.autoplayTimer);
        state.autoplayTimer = null;
      }
    }

    function canAutoplay() {
      if (!CONFIG.enableAutoplay) return false;
      if (state.gallerySlides.length <= 1) return false;
      if (document.hidden) return false;
      if (isMobileViewport() && !CONFIG.autoplayOnMobile) return false;
      return true;
    }

    function activeIsVideo() {
      const item = state.galleryItems[state.activeSlideIndex];
      return !!(item && item.mediaType === 'video');
    }

    function firstVideoSlideIndex() {
      for (let i = 0; i < state.galleryItems.length; i += 1) {
        if (state.galleryItems[i] && state.galleryItems[i].mediaType === 'video') return i;
      }
      return -1;
    }

    // Preview: before the user picks a pattern, cycle through each model and show
    // the matching pattern as selected so it's clear which model is displayed.
    function goToNextPreviewPattern() {
      if (!state.previewActive || !PATTERN_MAP.length) return;
      state.previewIndex = (state.previewIndex + 1) % PATTERN_MAP.length;
      const key = PATTERN_MAP[state.previewIndex].key;
      state.protectionSelections[0] = key;
      state.upsellHatPatternKey = key;
      clearAutoplay();
      renderSelectors();
      buildGallery(key);
    }

    function scheduleAutoplay() {
      clearAutoplay();
      if (!canAutoplay()) return;
      // Videos advance when they finish ('ended' handler), never on a timer.
      if (activeIsVideo()) return;

      state.autoplayTimer = window.setTimeout(function() {
        if (state.previewActive) {
          goToNextPreviewPattern();
        } else {
          goToSlide(state.activeSlideIndex + 1, true);
        }
      }, CONFIG.autoplayDelay);
    }

    function renderDots() {
      if (!mediaDots) return;

      const existingDots = mediaDots.querySelectorAll('.kdc-product-v13__dot');

      // Rebuild only when count changes (pattern switch)
      if (existingDots.length !== state.gallerySlides.length) {
        mediaDots.innerHTML = '';
        state.gallerySlides.forEach(function(_, index) {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'kdc-product-v13__dot';
          button.setAttribute('aria-label', (CONFIG.isFrench ? 'Image ' : 'Image ') + (index + 1));
          const progress = document.createElement('span');
          progress.className = 'kdc-product-v13__dot-progress';
          button.appendChild(progress);
          button.addEventListener('click', function() {
            if (index === state.activeSlideIndex) return;
            goToSlide(index, true);
          });
          mediaDots.appendChild(button);
        });
      }

      // Update active state and restart animation without full rebuild
      mediaDots.querySelectorAll('.kdc-product-v13__dot').forEach(function(dot, index) {
        const isActive = index === state.activeSlideIndex;
        dot.classList.toggle('is-active', isActive);
        const progress = dot.querySelector('.kdc-product-v13__dot-progress');
        if (progress) {
          if (isActive && canAutoplay()) {
            const clone = progress.cloneNode(false);
            clone.style.animationDuration = CONFIG.autoplayDelay + 'ms';
            dot.replaceChild(clone, progress);
          } else {
            progress.style.animationDuration = '';
          }
        }
      });
    }

    function setActiveSlide(index) {
      if (!state.gallerySlides.length) return;

      const safeIndex = (index + state.gallerySlides.length) % state.gallerySlides.length;
      state.activeSlideIndex = safeIndex;

      if (slidesEl) {
        slidesEl.style.transition = 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        slidesEl.style.transform = 'translateX(-' + (safeIndex * 100) + '%)';
      }

      renderDots();
      updateActiveMedia();
    }

    function goToSlide(index, restartAutoplay) {
      if (!state.gallerySlides.length) return;
      setActiveSlide(index);
      if (restartAutoplay) scheduleAutoplay();
    }

    function buildGallery(patternKey) {
      if (!slidesEl) return;

      const media = getMediaForPattern(patternKey);
      const gallery = media.gallery || [];

      // Bridge image: paint the model's poster behind the slides so a model swap
      // never flashes white during the rebuild/load gap (poster is preloaded).
      if (mediaStage) {
        var bgItem = null;
        for (var bi = 0; bi < gallery.length; bi += 1) {
          if (gallery[bi].mediaType === 'video' && gallery[bi].poster) { bgItem = gallery[bi]; break; }
        }
        if (!bgItem && gallery.length) bgItem = gallery[0];
        var bgUrl = bgItem ? (bgItem.poster || bgItem.src) : '';
        if (bgUrl) {
          mediaStage.style.backgroundImage = 'url("' + bgUrl + '")';
          mediaStage.style.backgroundSize = 'cover';
          mediaStage.style.backgroundPosition = 'center';
        }
      }

      slidesEl.innerHTML = '';
      slidesEl.style.transition = 'none';
      slidesEl.style.transform = 'translateX(0)';
      state.gallerySlides = [];
      state.galleryItems = [];
      state.activeSlideIndex = 0;
      state.galleryPatternKey = patternKey;

      gallery.forEach(function(item, index) {
        const slide = document.createElement('div');
        slide.className = 'kdc-product-v13__slide';
        if (index === 0) slide.classList.add('is-active');

        if (item.mediaType === 'video' && item.src) {
          const video = document.createElement('video');
          video.className = 'kdc-product-v13__slide-image kdc-product-v13__slide-video';
          // Source is loaded lazily — only the active slide's video gets a src
          // (see updateActiveMedia), so just one video downloads at a time.
          video.dataset.src = pickVideoSrc(item);
          if (item.poster) {
            video.poster = item.poster;
            // Paint the poster as the element background too, so a loading video never
            // flashes the cream slide background before its first frame.
            video.style.backgroundImage = 'url("' + item.poster + '")';
            video.style.backgroundSize = 'cover';
            video.style.backgroundPosition = 'center';
          }
          video.muted = true;
          video.playsInline = true;
          video.setAttribute('playsinline', '');
          video.setAttribute('muted', '');
          video.loop = false; // play once (one 360°) → advance on 'ended'
          video.controls = false;
          video.preload = 'none';
          slide.appendChild(video);
        } else {
          const img = document.createElement('img');
          img.className = 'kdc-product-v13__slide-image';
          img.alt = item.alt || CONFIG.displayTitle;
          img.decoding = 'async';
          img.loading = index < 2 ? 'eager' : 'lazy';
          if (index === 0) img.setAttribute('fetchpriority', 'high');

          img.src = item.src;
          if (item.srcset) {
            img.setAttribute('srcset', item.srcset);
            img.setAttribute('sizes', '(min-width: 990px) 42vw, 92vw');
          }
          slide.appendChild(img);
        }

        slidesEl.appendChild(slide);
        state.gallerySlides.push(slide);
        state.galleryItems.push(item);
      });

      if (!gallery.length) {
        const placeholder = document.createElement('div');
        placeholder.className = 'kdc-product-v13__placeholder';
        slidesEl.appendChild(placeholder);
      }

      renderDots();
      // In preview mode, jump straight to the model's video, instantly (no slide
      // animation) so changing models looks like a clean cut, not a swipe.
      if (state.previewActive) {
        const vi = firstVideoSlideIndex();
        if (vi > 0) {
          state.activeSlideIndex = vi;
          if (slidesEl) {
            slidesEl.style.transition = 'none';
            slidesEl.style.transform = 'translateX(-' + (vi * 100) + '%)';
          }
          renderDots();
        }
      }
      updateActiveMedia();
      scheduleAutoplay();
    }

    // Load + play only the active slide's video; pause and unload the others
    // so the page never downloads more than one video at a time.
    function updateActiveMedia() {
      state.gallerySlides.forEach(function(slide, i) {
        const video = slide.querySelector('video');
        if (!video) return;
        if (i === state.activeSlideIndex) {
          if (!video.getAttribute('src') && video.dataset.src) {
            video.setAttribute('src', video.dataset.src);
            video.load();
          }
          if (!video.dataset.kcEndBound) {
            video.dataset.kcEndBound = '1';
            video.addEventListener('ended', function () {
              // When the 360° clip finishes: next model in preview, else next slide.
              if (state.previewActive) {
                goToNextPreviewPattern();
              } else {
                goToSlide(state.activeSlideIndex + 1, true);
              }
            });
          }
          const playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
          if (video.getAttribute('src')) {
            video.removeAttribute('src');
            video.load();
          }
        }
      });
    }

    function ensureGalleryForPattern(patternKey) {
      if (state.galleryPatternKey === patternKey && state.gallerySlides.length) return;
      clearAutoplay();
      buildGallery(patternKey);
    }

    function clampQty(value) {
      let next = parseInt(value || '1', 10);
      if (!next || next < 1) next = 1;
      if (next > 12) next = 12;
      return next;
    }

    function syncSelectionsWithQuantity() {
      while (state.protectionSelections.length < state.quantity) {
        state.protectionSelections.push(state.protectionSelections[0] || CONFIG.defaultPatternKey);
      }

      if (state.protectionSelections.length > state.quantity) {
        state.protectionSelections = state.protectionSelections.slice(0, state.quantity);
      }
    }

    function buildVariantSummaryText() {
      const counts = new Map();

      state.protectionSelections.forEach(function(key) {
        counts.set(key, (counts.get(key) || 0) + 1);
      });

      if (state.quantity === 1) {
        return getPatternLabel(getPatternByKey(state.protectionSelections[0] || CONFIG.defaultPatternKey));
      }

      return Array.from(counts.entries()).map(function(entry) {
        return entry[1] + ' × ' + getPatternLabel(getPatternByKey(entry[0]));
      }).join(' · ');
    }

    function renderVariantSummary() {
      if (variantSummary) variantSummary.textContent = buildVariantSummaryText();
    }

    // Single top line: each chosen pattern with its price (all units full price).
    function renderSelectedLine() {
      var titlePrice = root.querySelector('#KDC-TitlePrice-' + SID);
      // 2026-10-07: with the offer on, the Liquid price (offer price, struck price, badge) stays as rendered.
      if (titlePrice && !titlePrice.hasAttribute('data-kdc-offer')) titlePrice.textContent = money(CONFIG.protectionPrice);
      if (!selectedLine) return;
      const fullPrice = CONFIG.protectionPrice;
      selectedLine.innerHTML = '';
      // 2026-09-12 (Émile): the line reads "Color: Cosmos" / "Couleur : Cosmos" (no age, no price).
      const colorLabel = document.createElement('span');
      colorLabel.className = 'kdc-product-v13__selected-label';
      colorLabel.textContent = CONFIG.isFrench ? 'Couleur : ' : 'Color: ';
      selectedLine.appendChild(colorLabel);
      for (let i = 0; i < state.quantity; i += 1) {
        const per = fullPrice;
        if (i > 0) {
          const sep = document.createElement('span');
          sep.className = 'kdc-product-v13__selected-sep';
          sep.textContent = '   ';
          selectedLine.appendChild(sep);
        }
        const p = getPatternByKey(state.protectionSelections[i] || CONFIG.defaultPatternKey);
        const item = document.createElement('span');
        item.className = 'kdc-product-v13__selected-item';
        const nm = document.createElement('span');
        nm.className = 'kdc-product-v13__selected-name';
        nm.textContent = getPatternLabel(p);
        const pr = document.createElement('span');
        pr.className = 'kdc-product-v13__selected-price';
        pr.textContent = ' · ' + money(per);
        item.appendChild(nm);
        // Price no longer repeated here: it sits under the title (2026-09-09, Russel).
        selectedLine.appendChild(item);
      }
    }

    // Swatch video (2026-10-01, Émile): only the CURRENT swatch carries a muted,
    // looping <video>; the other swatches keep their still image, so one small
    // file downloads at a time. On page load the default swatch's video waits for
    // the window 'load' event so it never competes with the LCP image; after a
    // click it starts at once (the click is the shopper's intent). Elements are
    // cached per pattern so a re-render does not refetch the file.
    var swatchVideoCache = {};
    // Browsers pause muted background videos when the tab is hidden; resume the
    // current swatch's loop when the shopper comes back.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      root.querySelectorAll('.kdc-product-v13__swatch.is-active .kdc-product-v13__swatch-video').forEach(function (cur) {
        if (cur.paused && cur.getAttribute('src')) { var p = cur.play(); if (p && p.catch) p.catch(function () {}); }
      });
    });
    var swatchVideoReady = document.readyState === 'complete';
    if (!swatchVideoReady) {
      window.addEventListener('load', function () {
        swatchVideoReady = true;
        root.querySelectorAll('.kdc-product-v13__swatch-video[data-deferred]').forEach(startSwatchVideo);
      }, { once: true });
    }
    function startSwatchVideo(video) {
      video.removeAttribute('data-deferred');
      var go = function () {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      };
      // Setting src then calling play() at once gets the play() aborted by the
      // src load that runs right after (AbortError). Load first, play on metadata.
      if (!video.getAttribute('src')) {
        video.src = video.dataset.src;
        video.load();
        video.addEventListener('loadedmetadata', go, { once: true });
      } else {
        go();
      }
    }
    function mountSwatchVideo(button, item, patternKey) {
      var video = swatchVideoCache[patternKey];
      if (!video) {
        video = document.createElement('video');
        video.className = 'kdc-product-v13__swatch-video';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('loop', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('aria-hidden', 'true');
        video.tabIndex = -1;
        video.preload = 'none';
        video.disablePictureInPicture = true;
        if (item.poster) video.poster = item.poster;
        video.dataset.src = pickVideoSrc(item);
        video.addEventListener('playing', function () { button.classList.add('has-video-playing'); });
        swatchVideoCache[patternKey] = video;
      }
      button.appendChild(video);
      if (swatchVideoReady) startSwatchVideo(video); else video.setAttribute('data-deferred', '');
    }

    // One row of 4 pattern swatches. When quantity > 1, unit numbers (1, 2, 3…)
    // sit on the corner of the swatch each unit is assigned to. Clicking a swatch
    // assigns the active unit to it, then advances to the next unit.
    function renderSwatchRow() {
      if (!swatchRow) return;
      if (state.activeUnit >= state.quantity) state.activeUnit = state.quantity - 1;
      swatchRow.innerHTML = '';

      PATTERN_MAP.forEach(function (pattern) {
        const media = getMediaForPattern(pattern.key);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kdc-product-v13__swatch';
        button.setAttribute('aria-label', getPatternLabel(pattern));
        button.dataset.patternKey = pattern.key;
        // protectionId is configured to the CURRENT product's own variant for this
        // pattern (both templates set protection_variant_* to their on-page product),
        // so the low-stock line can read this pattern's REAL inventory.
        if (pattern.protectionId) button.dataset.variantId = pattern.protectionId;

        if (media.swatch && media.swatch.src) {
          const img = document.createElement('img');
          img.className = 'kdc-product-v13__swatch-image';
          img.src = media.swatch.src;
          img.alt = media.swatch.alt || getPatternLabel(pattern);
          img.loading = 'lazy';
          img.decoding = 'async';
          button.appendChild(img);
        } else {
          const fallback = document.createElement('span');
          fallback.className = 'kdc-product-v13__swatch-fallback';
          fallback.textContent = getPatternLabel(pattern).charAt(0);
          button.appendChild(fallback);
        }

        // Which units are currently on this pattern
        const units = [];
        for (let i = 0; i < state.quantity; i += 1) {
          if ((state.protectionSelections[i] || CONFIG.defaultPatternKey) === pattern.key) units.push(i + 1);
        }
        if (units.length) button.classList.add('is-active');
        if ((state.protectionSelections[state.activeUnit] || CONFIG.defaultPatternKey) === pattern.key) {
          button.classList.add('is-current');
        }
        // 2026-10-08 (Émile): every pattern chosen by a unit plays its video, so 2 hats = 2 videos,
        // 3 hats = 3 videos (one per pattern; two units on the same pattern share one).
        if (units.length && media.swatchVideo) mountSwatchVideo(button, media.swatchVideo, pattern.key);

        if (state.quantity > 1 && units.length) {
          const numsWrap = document.createElement('span');
          numsWrap.className = 'kdc-product-v13__swatch-nums';
          units.forEach(function (u) {
            const dot = document.createElement('span');
            dot.className = 'kdc-product-v13__swatch-num';
            dot.textContent = u;
            numsWrap.appendChild(dot);
          });
          button.appendChild(numsWrap);
        }

        // Intent-based preload: interest in a swatch warms that pattern's video.
        button.addEventListener('pointerenter', function () { warmPatternVideo(pattern.key); }, { once: true });
        button.addEventListener('touchstart', function () { warmPatternVideo(pattern.key); }, { once: true, passive: true });

        button.addEventListener('click', function () {
          // User picked a pattern → stop the auto-preview of models.
          state.previewActive = false;
          const unit = state.activeUnit;
          state.protectionSelections[unit] = pattern.key;
          state.upsellHatPatternKey = state.protectionSelections[0];
          if (state.quantity > 1) state.activeUnit = (state.activeUnit + 1) % state.quantity;
          // Show the chosen (primary) pattern's gallery normally, exiting preview.
          state.galleryPatternKey = null;
          ensureGalleryForPattern(state.protectionSelections[0] || pattern.key);
          render({ syncGallery: false });
        });

        swatchRow.appendChild(button);
      });
    }

    function renderSelectors() {
      renderSelectedLine();
      renderSwatchRow();
    }

    function getPricing() {
      const count = state.protectionSelections.length;
      // Every unit is full price — no multi-unit discount.
      const subtotal = count * CONFIG.protectionPrice;
      const finalProductTotal = subtotal;
      // 2026-10-07 (Émile): no more free shipping.
      const freeShipping = false;

      return {
        subtotal: subtotal,
        discountRate: 0,
        discountAmount: 0,
        finalProductTotal: finalProductTotal,
        freeShipping: freeShipping
      };
    }

    function renderPricing() {
      const pricing = getPricing();

      if (priceCurrent) priceCurrent.textContent = money(pricing.finalProductTotal);

      if (priceCompare) {
        const hasCompare = pricing.discountAmount > 0;
        priceCompare.hidden = !hasCompare;
        priceCompare.textContent = hasCompare ? money(pricing.subtotal) : '';
      }

      if (priceBadges) {
        priceBadges.innerHTML = '';

        if (pricing.freeShipping) {
          const freeBadge = document.createElement('span');
          freeBadge.className = 'kdc-product-v13__price-badge';
          freeBadge.textContent = CONFIG.shippingBadgeText;
          priceBadges.appendChild(freeBadge);
        }

        if (pricing.discountRate > 0) {
          const discBadge = document.createElement('span');
          discBadge.className = 'kdc-product-v13__price-badge';
          discBadge.textContent = pricing.discountRate + ' ' + CONFIG.discountSuffix;
          priceBadges.appendChild(discBadge);
        }
      }

      // Inline discount badge near the qty controls
      if (discountBadge) {
        if (pricing.discountRate > 0) {
          discountBadge.hidden = false;
          discountBadge.textContent = pricing.discountRate + ' ' + CONFIG.discountSuffix;
        } else {
          discountBadge.hidden = true;
          discountBadge.textContent = '';
        }
      }

      if (shippingLine) {
        shippingLine.textContent = pricing.freeShipping
          ? CONFIG.freeShippingText
          : money(CONFIG.shippingPrice) + ' ' + CONFIG.shippingSuffixText;
      }
    }

    // Delivery windows are quoted in BUSINESS days (jours ouvrables):
    // weekends don't count toward the estimate.
    function addDays(date, days) {
      const next = new Date(date);
      let remaining = days;
      while (remaining > 0) {
        next.setDate(next.getDate() + 1);
        const dow = next.getDay();
        if (dow !== 0 && dow !== 6) remaining -= 1;
      }
      return next;
    }

    function formatDeliveryDate(date) {
      return date.toLocaleDateString(CONFIG.isFrench ? 'fr-CA' : 'en-CA', {
        day: 'numeric',
        month: 'short'
      });
    }

    function renderDeliveryEstimate() {
      if (!deliveryInlineEl) return;

      if (!CONFIG.deliveryPrefix || !CONFIG.deliveryMinDays || !CONFIG.deliveryMaxDays || CONFIG.deliveryMinDays > CONFIG.deliveryMaxDays) {
        deliveryInlineEl.textContent = '';
        return;
      }

      const now = new Date();
      const minDate = addDays(now, CONFIG.deliveryMinDays);
      const maxDate = addDays(now, CONFIG.deliveryMaxDays);

      const locale = CONFIG.isFrench ? 'fr-CA' : 'en-CA';
      const monthMin = minDate.toLocaleDateString(locale, { month: 'short' });
      const monthMax = maxDate.toLocaleDateString(locale, { month: 'short' });
      // Word connector (no dash): FR "13 au 19 juill.", EN "13 to 19 Jul".
      const sep = CONFIG.isFrench ? ' au ' : ' to ';
      const range = (monthMin === monthMax)
        ? minDate.getDate() + sep + maxDate.getDate() + ' ' + monthMax
        : minDate.getDate() + ' ' + monthMin + sep + maxDate.getDate() + ' ' + monthMax;
      // Also spell out the window in days so the estimate is explicit:
      // FR "(2 à 5 jours)", EN "(2 to 5 days)".
      const daysSuffix = CONFIG.isFrench
        ? ' (' + CONFIG.deliveryMinDays + ' à ' + CONFIG.deliveryMaxDays + ' jours)'
        : ' (' + CONFIG.deliveryMinDays + ' to ' + CONFIG.deliveryMaxDays + ' days)';
      deliveryInlineEl.textContent = CONFIG.deliveryPrefix + ' ' + range + daysSuffix;
    }

    function aggregateItems(items) {
      const map = new Map();

      items.forEach(function(item) {
        if (!item || !item.id) return;
        const key = String(item.id);

        if (!map.has(key)) {
          map.set(key, { id: item.id, quantity: item.quantity || 1 });
        } else {
          map.get(key).quantity += item.quantity || 1;
        }
      });

      return Array.from(map.values());
    }

    function buildProtectionItems() {
      return aggregateItems(
        state.protectionSelections.map(function(patternKey) {
          const pattern = getPatternByKey(patternKey);
          return { id: pattern.protectionId, quantity: 1 };
        })
      );
    }

    function buildUpsellHatItem() {
      const pattern = getPatternByKey(state.upsellHatPatternKey || state.protectionSelections[0] || CONFIG.defaultPatternKey);
      return pattern && pattern.hatId ? { id: pattern.hatId, quantity: 1 } : null;
    }

    async function addItemsToCart(items) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Add to cart failed');
      }

      return response.json();
    }

    function updateCartCount() {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          const cartLink = document.getElementById('cart-icon-bubble');
          if (!cartLink) return;
          let countEl = cartLink.querySelector('.kdc-header__cart-count');
          if (cart.item_count > 0) {
            const text = cart.item_count < 100 ? String(cart.item_count) : '99+';
            if (!countEl) {
              countEl = document.createElement('span');
              countEl.className = 'kdc-header__cart-count';
              cartLink.appendChild(countEl);
            }
            countEl.textContent = text;
          } else if (countEl) {
            countEl.remove();
          }
        })
        .catch(function() {});
    }

    function openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) return;

      // The Safety Cart drawer shows/animates purely off the `active` class and
      // self-refreshes its contents from /cart.js when that class is added
      // (MutationObserver in cart-drawer snippet). Add it directly so we don't
      // depend on Dawn's open() which is tuned for different markup.
      cartDrawer.classList.remove('is-empty');
      cartDrawer.classList.add('active');
      document.body.classList.add('overflow-hidden');

      // Belt-and-suspenders: also call Dawn's open() if present, and ping refresh.
      try { if (typeof cartDrawer.open === 'function') cartDrawer.open(); } catch (e) {}
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }

    function buildCheckoutForm(items) {
      const form = document.createElement('form');
      form.method = 'post';
      form.action = '/cart/add';

      items.forEach(function(item, index) {
        const idInput = document.createElement('input');
        idInput.type = 'hidden';
        idInput.name = 'items[' + index + '][id]';
        idInput.value = item.id;
        form.appendChild(idInput);

        const qtyInputHidden = document.createElement('input');
        qtyInputHidden.type = 'hidden';
        qtyInputHidden.name = 'items[' + index + '][quantity]';
        qtyInputHidden.value = item.quantity;
        form.appendChild(qtyInputHidden);
      });

      const returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      returnTo.value = '/checkout';
      form.appendChild(returnTo);

      document.body.appendChild(form);
      return form;
    }

    function goDirectToCheckout(items) {
      const form = buildCheckoutForm(items);
      form.submit();
    }

    function setButtonLoading(button, isLoading) {
      if (!button) return;
      button.disabled = isLoading;
      button.classList.toggle('is-loading', isLoading);
    }

    function pulseAdded(button) {
      if (!button) return;
      button.classList.remove('is-added');
      void button.offsetWidth;
      button.classList.add('is-added');

      window.setTimeout(function() {
        button.classList.remove('is-added');
      }, 1200);
    }

    let feedbackTimer = null;
    function setFeedback(text) {
      if (!feedbackEl) return;
      feedbackEl.textContent = text || '';
      if (feedbackTimer) { clearTimeout(feedbackTimer); feedbackTimer = null; }
      if (text) {
        // Auto-clear so "Ajouté au panier" doesn't linger after the item is gone.
        feedbackTimer = setTimeout(function() {
          if (feedbackEl) feedbackEl.textContent = '';
        }, 2500);
      }
    }

    let toastTimer = null;
    function showToast(text) {
      if (!toast || !toastInner) return;
      toastInner.textContent = text || '';
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');

      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function() {
        toast.classList.remove('is-visible');
        toast.setAttribute('aria-hidden', 'true');
      }, 2500);
    }

    function shouldShowUpsell() {
      // Popup removed 2026-09-08 (Russel): add to cart opens the drawer directly.
      if (!CONFIG.enableUpsellPopup) return false;
      return state.quantity === 1 && !!buildUpsellHatItem();
    }

    function renderUpsellSwatches() {
      if (!upsellSwatches) return;
      upsellSwatches.innerHTML = '';

      PATTERN_MAP.forEach(function(pattern) {
        const media = getMediaForPattern(pattern.key);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kdc-product-v13__upsell-swatch';
        button.setAttribute('aria-label', getPatternLabel(pattern));

        if (state.upsellHatPatternKey === pattern.key) {
          button.classList.add('is-active');
        }

        if (media.swatch && media.swatch.src) {
          const img = document.createElement('img');
          img.src = media.swatch.src;
          img.alt = media.swatch.alt || getPatternLabel(pattern);
          img.loading = 'lazy';
          img.decoding = 'async';
          button.appendChild(img);
        } else {
          const fallback = document.createElement('span');
          fallback.textContent = getPatternLabel(pattern).charAt(0);
          button.appendChild(fallback);
        }

        button.addEventListener('click', function() {
          state.upsellHatPatternKey = pattern.key;
          renderUpsellSwatches();
        });

        upsellSwatches.appendChild(button);
      });
    }

    function openUpsell(mode) {
      if (!upsell || !shouldShowUpsell()) return;
      state.upsellMode = mode || 'cart';

      renderUpsellSwatches();

      if (upsellPrice) {
        if (CONFIG.hatSalePrice < CONFIG.hatPrice) {
          // Fixed dollar discount: compare-at price crossed out, sale price + "$X off" badge.
          var upsellSaveDollars = Math.round((CONFIG.hatPrice - CONFIG.hatSalePrice) / 100);
          var upsellSaveLabel = CONFIG.isFrench ? (upsellSaveDollars + ' $ de rabais') : ('$' + upsellSaveDollars + ' off');
          upsellPrice.innerHTML = '<s style="opacity:.5">' + money(CONFIG.hatPrice) + '</s> <strong>' + money(CONFIG.hatSalePrice) + '</strong> <span style="background:#181d3a;color:#ffffff;border-radius:999px;padding:2px 8px;font-size:11px;vertical-align:middle;">' + upsellSaveLabel + '</span>';
        } else {
          upsellPrice.textContent = money(CONFIG.hatSalePrice);
        }
      }
      if (upsellPrimary) {
        upsellPrimary.textContent = state.upsellMode === 'checkout'
          ? CONFIG.upsellAddCheckoutText
          : CONFIG.upsellAddCartText;
      }

      upsell.classList.add('is-open');
      upsell.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('kdc-no-scroll');
    }

    function closeUpsell() {
      if (!upsell) return;
      upsell.classList.remove('is-open');
      upsell.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('kdc-no-scroll');
      state.upsellMode = null;
    }

    async function handleUpsellPrimary() {
      const hatItem = buildUpsellHatItem();
      if (!hatItem) {
        closeUpsell();
        return;
      }

      if (state.upsellMode === 'checkout') {
        const checkoutItems = aggregateItems((state.pendingBuyNowItems || []).concat([hatItem]));
        goDirectToCheckout(checkoutItems);
        return;
      }

      try {
        setButtonLoading(upsellPrimary, true);
        const data = await addItemsToCart([hatItem]);
        closeUpsell();
        showToast(CONFIG.toastHatAdded);
        updateCartCount();
        openCartDrawer(data && data.sections);
      } catch (error) {
        console.error(error);
        setFeedback(CONFIG.errorText);
      } finally {
        setButtonLoading(upsellPrimary, false);
      }
    }

    function handleUpsellSecondary() {
      if (state.upsellMode === 'checkout') {
        goDirectToCheckout(aggregateItems(state.pendingBuyNowItems || []));
        return;
      }
      closeUpsell();
      openCartDrawer();
    }

    function render(options) {
      const opts = options || {};
      syncSelectionsWithQuantity();
      renderSelectors();
      renderVariantSummary();
      renderPricing();
      renderDeliveryEstimate();

      if (opts.syncGallery !== false) {
        ensureGalleryForPattern(state.protectionSelections[0] || CONFIG.defaultPatternKey);
      }
    }

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        state.quantity = clampQty(state.quantity - 1);
        if (qtyInput) qtyInput.value = state.quantity;
        render({ syncGallery: false });
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        state.quantity = clampQty(state.quantity + 1);
        if (qtyInput) qtyInput.value = state.quantity;
        // The newly added unit becomes active so its number is ready to place.
        state.activeUnit = state.quantity - 1;
        render({ syncGallery: false });
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function() {
        state.quantity = clampQty(qtyInput.value);
        qtyInput.value = state.quantity;
        render({ syncGallery: false });
      });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', async function() {
        const items = buildProtectionItems();
        if (!items.length) return;

        try {
          setFeedback('');
          setButtonLoading(addToCartBtn, true);
          const data = await addItemsToCart(items);
          pulseAdded(addToCartBtn);
          setFeedback(CONFIG.feedbackAdded);
          showToast(CONFIG.toastAdded);
          updateCartCount();

          state.pendingBuyNowItems = null;

          // Post-ATC upsell popup (as on the original launch theme), then the drawer.
          if (shouldShowUpsell()) {
            openUpsell('cart');
          } else {
            openCartDrawer(data && data.sections);
          }
        } catch (error) {
          console.error(error);
          setFeedback(CONFIG.errorText);
        } finally {
          setButtonLoading(addToCartBtn, false);
        }
      });
    }

    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', function() {
        const items = buildProtectionItems();
        if (!items.length) return;

        try {
          setFeedback('');
          setButtonLoading(buyNowBtn, true);

          if (shouldShowUpsell()) {
            state.pendingBuyNowItems = items;
            openUpsell('checkout');
            setButtonLoading(buyNowBtn, false);
            return;
          }

          goDirectToCheckout(items);
        } catch (error) {
          console.error(error);
          setFeedback(CONFIG.errorText);
          setButtonLoading(buyNowBtn, false);
        }
      });
    }

    if (upsellPrimary) upsellPrimary.addEventListener('click', handleUpsellPrimary);
    if (upsellSecondary) upsellSecondary.addEventListener('click', handleUpsellSecondary);

    upsellCloseEls.forEach(function(el) {
      el.addEventListener('click', function() {
        closeUpsell();
      });
    });

    if (mediaPrev) {
      mediaPrev.addEventListener('click', function() {
        state.previewActive = false;
        goToSlide(state.activeSlideIndex - 1, true);
      });
    }

    if (mediaNext) {
      mediaNext.addEventListener('click', function() {
        state.previewActive = false;
        goToSlide(state.activeSlideIndex + 1, true);
      });
    }

    if (mediaStage) {
      // Only pause autoplay on hover for devices that actually hover (desktop).
      // On touch screens a tap fires mouseenter and would kill autoplay forever.
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        mediaStage.addEventListener('mouseenter', clearAutoplay);
        mediaStage.addEventListener('mouseleave', scheduleAutoplay);
      }

      mediaStage.addEventListener('touchstart', function(e) {
        state.previewActive = false; // user is interacting → stop auto-preview
        state.touchStartX = e.touches[0].clientX;
        state.touchStartTime = Date.now();
        state.touchDeltaX = 0;
        if (slidesEl) slidesEl.style.transition = 'none';
        clearAutoplay();
      }, { passive: true });

      mediaStage.addEventListener('touchmove', function(e) {
        state.touchDeltaX = e.touches[0].clientX - state.touchStartX;
        if (slidesEl) {
          slidesEl.style.transform = 'translateX(calc(-' + (state.activeSlideIndex * 100) + '% + ' + state.touchDeltaX + 'px))';
        }
      }, { passive: true });

      mediaStage.addEventListener('touchend', function() {
        const elapsed = Date.now() - state.touchStartTime;
        const velocity = Math.abs(state.touchDeltaX) / Math.max(elapsed, 1);
        const isFastFlick = velocity > 0.3 && Math.abs(state.touchDeltaX) > 15;
        const isLongSwipe = Math.abs(state.touchDeltaX) > 40;

        if (isFastFlick || isLongSwipe) {
          if (state.touchDeltaX < 0) {
            goToSlide(state.activeSlideIndex + 1, true);
          } else {
            goToSlide(state.activeSlideIndex - 1, true);
          }
        } else {
          if (slidesEl) {
            slidesEl.style.transition = 'transform 0.38s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            slidesEl.style.transform = 'translateX(-' + (state.activeSlideIndex * 100) + '%)';
          }
          scheduleAutoplay();
        }

        state.touchStartX = 0;
        state.touchStartTime = 0;
        state.touchDeltaX = 0;
      }, { passive: true });
    }

    document.addEventListener('visibilitychange', function() {
      if (document.hidden) {
        clearAutoplay();
      } else {
        scheduleAutoplay();
      }
    });

    let _resizeTimer = null;
    window.addEventListener('resize', function() {
      if (_resizeTimer) clearTimeout(_resizeTimer);
      _resizeTimer = setTimeout(scheduleAutoplay, 150);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && upsell && upsell.classList.contains('is-open')) {
        closeUpsell();
      }
    });

    // Pick the right video rendition for the device: phones get the SD file
    // (visually identical in a small gallery), desktop gets HD.
    function pickVideoSrc(item) {
      if (item.sdSrc && window.innerWidth < 990) return item.sdSrc;
      return item.src;
    }

    // Video preloading is INTENT-BASED, never warm-everything: the old
    // version downloaded every model's HD 360° video (~4-5 MB) on each page
    // load, which crushed mobile load times. Now a pattern's video is
    // warmed only when the shopper shows interest in that swatch
    // (hover/first touch), plus posters after idle so model switches never
    // flash white.
    var warmedPatterns = {};
    function warmPatternVideo(patternKey) {
      if (warmedPatterns[patternKey]) return;
      if (navigator.connection && navigator.connection.saveData) return;
      warmedPatterns[patternKey] = true;
      const media = getMediaForPattern(patternKey);
      (media.gallery || []).forEach(function (item) {
        if (item.mediaType === 'video' && item.src) {
          const v = document.createElement('video');
          v.muted = true;
          v.preload = 'auto';
          v.src = pickVideoSrc(item);
          v.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;pointer-events:none;';
          try { v.load(); } catch (e) {}
          document.body.appendChild(v);
          // Free the preloader element once it has buffered (the HTTP cache
          // keeps the bytes; the element itself is no longer needed).
          v.addEventListener('canplaythrough', function () {
            setTimeout(function () { if (v.parentNode) v.parentNode.removeChild(v); }, 1000);
          }, { once: true });
        }
      });
    }
    function schedulePreloadPosters() {
      if (navigator.connection && navigator.connection.saveData) return;
      const kick = function () {
        const run = function () {
          PATTERN_MAP.forEach(function (p) {
            const media = getMediaForPattern(p.key);
            (media.gallery || []).forEach(function (item) {
              if (item.poster) { const im = new Image(); im.src = item.poster; }
            });
          });
        };
        if ('requestIdleCallback' in window) requestIdleCallback(run, { timeout: 6000 });
        else setTimeout(run, 3000);
      };
      if (document.readyState === 'complete') kick();
      else window.addEventListener('load', kick, { once: true });
    }
    schedulePreloadPosters();

    // Live review count (2026-10-01): the buy-box rating renders from Shopify
    // metafields. The old cdn.judge.me fetch was blocked by CORS on every page
    // load (a console error, never a value), so we now read the Judge.me widget
    // once it has rendered lower on the page: no network call, no error, and the
    // header always matches the reviews section. 2026-10-09 (Émile): format "4.9 · 56 avis",
    // never "4.9 (56)" which read as 4.956.
    (function syncLiveRating() {
      var tries = 0;
      function attempt() {
        var w = document.querySelector('#judgeme_product_reviews');
        var avgEl = w && w.querySelector('.jdgm-rev-widg__summary-average');
        var txtEl = w && w.querySelector('.jdgm-rev-widg__summary-text');
        if (!avgEl || !txtEl) { if (tries++ < 30) setTimeout(attempt, 700); return; }
        var avg = parseFloat((avgEl.textContent || '').replace(',', '.'));
        var m = (txtEl.textContent || '').match(/(\d+)/);
        var n = m ? parseInt(m[1], 10) : 0;
        if (!n || !avg) return;
        var count = root.querySelector('.kdc-product-v13__rating-count');
        var score = root.querySelector('.kdc-product-v13__rating-score');
        var fill = root.querySelector('.kdc-product-v13__rating-stars-fill');
        if (count) count.textContent = '· ' + n + (CONFIG.isFrench ? ' avis' : ' reviews');
        if (score) score.textContent = avg.toFixed(1);
        if (fill) fill.style.width = (avg * 20) + '%';
      }
      try { attempt(); } catch (e) {}
    })();

    // Parallax: hide the pinned media once the content panel covers it.
    const buyboxEl = root.querySelector('.kdc-product-v13__buybox');
    const mediaColEl = root.querySelector('.kdc-product-v13__media-col');
    function updateMediaVisibility() {
      if (!buyboxEl || !mediaColEl) return;
      mediaColEl.classList.toggle('kdc-media-hidden', buyboxEl.getBoundingClientRect().top <= 0);
    }
    window.addEventListener('scroll', updateMediaVisibility, { passive: true });
    window.addEventListener('resize', updateMediaVisibility, { passive: true });
    updateMediaVisibility();

    if (qtyInput) qtyInput.value = state.quantity;
    render();
  }

  var queue = window.KDC_PP_BOOT = window.KDC_PP_BOOT || [];
  window.KDC_PP_INIT = function () {
    while (queue.length) {
      var b = queue.shift();
      if (!b || !b.root || b.root.dataset.kdcPpBound === 'true') continue;
      b.root.dataset.kdcPpBound = 'true';
      try { initSection(b.root, b.PATTERN_MAP, b.CONFIG); } catch (e) { console.error('KDC product premium', e); }
    }
  };
  window.KDC_PP_INIT();
})();
